import { render, staticRenderFns } from "./WoozyLayer.vue?vue&type=template&id=19c7150b&"
import script from "./WoozyLayer.vue?vue&type=script&lang=js&"
export * from "./WoozyLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports